import React, { useState, useEffect } from 'react';

import '../assets/css/Item.scss';
import history from '../history';

const Item = ({ width, image, title, specialFactor, obj }) => {
  const [pyme, setPyme] = useState(null);

  useEffect(() => {
    setPyme(obj._source);
  }, [obj._source]);

  const displayPymeInfo = (pyme) => {
    let rut = clearRut(pyme.rutPyme);
    history.push('/pyme/details/' + rut, pyme);
    history.go();
  };

  const clearRut = (rut) => {
    return rut.replace(/[^A-Za-z0-9]+/gi, '').toUpperCase();
  };

  return (
    <div
      className={'col-12 col-md-6 col-xl-' + width}
      onClick={() => displayPymeInfo(pyme)}
    >
      <div className="card card-box">
        <div className="card-body">
          <table style={{ width: '100%' }}>
            <tbody>
              <tr style={{ width: '100%' }}>
                <td style={{ width: '50px' }}>
                  {image !== null && typeof image !== 'undefined' ? (
                    <div className="img-box">
                      <img className="img-square" src={image} alt="company" />
                    </div>
                  ) : (
                    <div className="img-box">
                      <img
                        className="img-square"
                        src={'/img/default-img.svg'}
                        alt="company"
                      />
                    </div>
                  )}
                </td>
                <td className="description">
                  <div className="item-box-description l-p-10"><strong>{title}</strong></div>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <div className="item-box-data">
                    <span className="card-special-factor">
                      {specialFactor}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Item;
